<template>
  <div class="page_main">
    <Spin fix size="large" v-if="table_loading"></Spin>

    <div class="page_tabs">
      <div class="search_div">
        <Input v-model="search_value" clearable search @on-enter="search_click" size="small" placeholder="搜索姓名"
          style="width: 100px" />
        <!-- <span style="font-size: 12px; color: red; margin-left: 5px"
          >待操作表中当天未到的人员请及时操作为【未到】</span
        > -->
      </div>

      <div class="tabs_div">
        <Tabs v-if="tabs_show" size="small" :v-model="tabs_index" @on-click="click_tabs">
          <TabPane v-for="(item, i) in flow_class_list" :key="i" :name="item.value" :label="item.label">
          </TabPane>
        </Tabs>
      </div>
      <div class="button_operation">
        <div v-if="is_action" class="button_1">
          <Button @click="click_action(item)" v-for="(item, i) in action_list" :key="i" :loading="button_loading"
            size="small" style="font-size: 12px; margin-right: 10px" type="primary">{{ item.label }}
          </Button>
        </div>
        <Button v-if="tabs_index == 'FLOW_89B19'" size="small" style="font-size: 12px" type="success"
          @click="click_new_mianshi_button">
          <Icon type="md-add" /> 添加新面试
        </Button>
        <Button v-if="tabs_index == 'FLOW_89B19'" size="small" style="font-size: 12px; margin-left: 10px" type="success"
          @click="batch_mianshi">
          批量面试
        </Button>
        <Button v-if="tabs_index == 'FLOW_89B19'" size="small" style="font-size: 12px; margin-left: 10px" type="error"
          @click="click_del_interview">
          <Icon type="md-trash" /> 删除
        </Button>
        <Button @click="click_get_back" v-if="tabs_index == 'FLOW_BDF19' || tabs_index == 'FLOW_2FB96'" size="small"
          style="font-size: 12px; margin-left: 10px" type="warning" :loading="button_loading">
          <Icon type="ios-arrow-dropleft" /> 返回上一步
        </Button>
      </div>
    </div>

    <div class="table_div">
      <Table size="small" :height="windowHeight - 185" :columns="columns" :data="table_data"
        @on-selection-change="tabs_selection_change">
        <template #name="{ row }">
          <span class="name" @click="click_name(row)">{{ row.name }}</span>
        </template>
        <template #belong_name="{ row }">
          <span class="belong_name" :title="row.belong_phone" @click="click_update_guishu(row)">{{ row.belong_name
            }}</span>
        </template>

        <template #idcard="{ row }">
          <div>
            <span class="idcard2" @click="click_idcard_num(row)">{{
              row.idcard
            }}</span>
            <i title="已实名" v-if="row.is_certification == 1" class="iconfont iconrenzheng"></i>
            <i title="未实名" v-else class="iconfont iconweirenzheng" @click="click_update_certification(row)"></i>
          </div>
        </template>
        <template #job_name="{ row }">
          <span class="idcard_num" @click="click_job_name(row)">{{ row.job_name }}

            <Icon type="ios-create-outline" size="14" color="#0466dd" />
          </span>
        </template>
        <template #remarks="{ row }">
          <span class="idcard_num" @click="click_update_remarks(row)">{{ row.remarks }}
            <Icon type="ios-create-outline" size="14" color="#0466dd" />
          </span>
        </template>

        <template #phone="{ row }">
          <div @click="click_update_phone(row)">
            <span class="phone_span">{{ row.phone }}</span>
            <Icon class="phone_icon" type="ios-create-outline" />
          </div>
        </template>
      </Table>
      <div class="content_page">
        <!--   show-sizer
          :page-size-opts="[20,50]"
          @on-page-size-change="page_size_change"
          :total="total_count" -->
        <Page show-total show-elevator :total="total_count" :page-size="limit" @on-change="page_change" />
      </div>
    </div>

    <!-- 更新手机号 -->
    <Modal v-model="update_phone_show" title="更新手机号" :footer-hide="true" width="300">
      <div>
        <Input maxlength="11" v-model="update_phone_value" placeholder="输入11位手机号码" style="width: 200px" />
      </div>
      <div class="update_phone_button">
        <Button type="primary" @click="update_phone">确认更新</Button>
      </div>
    </Modal>

    <!-- 添加新面试 -->
    <Modal v-model="add_resume_show" title="添加新面试" :footer-hide="true" width="620">
      <div class="zyts">
        重要提示：手机号系统内一人一号，需要唯一，提交后手机号不可修改，请添加时确认手机号码可用！
      </div>
      <div class="add_modal">
        <div class="field_item_box">
          <div class="field_item">
            <div class="field_title">姓名：</div>
            <Input v-model="add_mianshi_data.name" placeholder="请输入真实姓名(必填)" style="width: 200px" />
          </div>


        </div>
        <div class="field_item_box">

          <div class="field_item">
            <div class="field_title">手机号：</div>
            <Input maxlength="11" v-model="add_mianshi_data.phone" placeholder="请输入手机号(必填)" style="width: 200px"
              @on-blur="phone_blur" />
            <check_phone_empty ref="check_phone_empty"></check_phone_empty>
          </div>

        </div>
        <div class="field_item_box">
          <div class="field_item">
            <div class="field_title">身份证号：</div>
            <Input maxlength="18" v-model="add_mianshi_data.idcard" placeholder="请输入身份证号(选填)" style="width: 200px" />
          </div>

        </div>
        <div class="hengxian"></div>
        <div class="field_item_box">
          <div class="field_item">
            <div class="field_title">预约面试时间：</div>
            <div>
              <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="add_mianshi_data.beforehand_time"
                placeholder="选择面试日期" style="width: 200px" />
            </div>
          </div>
        </div>
        <div class="field_item_box">
          <div class="field_title">项目需求岗位：</div>
          <div class="job_div">
            <Select v-model="need_job_id" style="width:450px" placeholder="请选择岗位">
              <Option v-for="item in need_job_list" :value="item.id" :key="item.id">{{ item.job_name }} | {{ item.salary }}元/{{
                item.salary_type }} | 需求{{ item.need_count }}人  </Option>
            </Select>
            <Icon @click="job_refresh" class="refresh_icon" type="ios-refresh" size="24" style="margin-left:5px" />

          </div>
        </div>

        <!-- <div class="field_item_box">
          <div class="field_item">
            <div class="field_title">岗位：</div>
            <Input maxlength="18" v-model="add_mianshi_data.job" placeholder="请输入面试岗位" style="width: 450px" />
          </div>
        </div> -->
        <div class="field_item_box" style="margin-top:10px">
          <div class="field_item">
            <div class="field_title">面试备注：</div>
            <Input maxlength="18" v-model="add_mianshi_data.remarks" placeholder="请输入" style="width: 450px" />
          </div>
        </div>

        <div class="hengxian"></div>
        <div class="field_item_box" >
          <div class="field_item">
            <div class="field_title">归属人类型：</div>
            <div>
              <Select clearable filterable v-model="add_mianshi_data.belong_type" style="width: 200px">
                <Option v-for="(item, i) in belong_type_list" :value="item.value" :key="item.value">{{ item.label }}
                </Option>
              </Select>
            </div>
          </div>
        </div>
        <div class="field_item_box" v-if="add_mianshi_data.belong_type == 'B01'">
          <div class="field_item">
            <div class="field_title">归属人姓名：</div>
            <Select v-if="sys_user_list" filterable clearable placeholder="请搜索或选择用户"
              v-model="add_mianshi_data.belong_id" style="width: 450px">
              <Option v-for="(item, i) in sys_user_list" :value="String(item.value)" :key="String(item.value)">{{
                item.label
                }}</Option>
            </Select>
          </div>
        </div>
        <div v-if="add_mianshi_data.belong_type == 'B02'">
          <div class="field_item_box">
            <div class="field_item">
              <div class="field_title">姓名：</div>
              <Input maxlength="11" v-model="add_mianshi_data.belong_name" placeholder="请输入(必填)" style="width: 130px" />
            </div>
            <div class="field_item">
              <div class="field_title">身份证号：</div>
              <Input maxlength="18" v-model="add_mianshi_data.belong_id" placeholder="请输入身份证号(选填)"
                style="width: 200px" />
            </div>
          </div>
          <div class="field_item_box">
            <div class="field_item">
              <div class="field_title">手机号：</div>
              <Input maxlength="11" v-model="add_mianshi_data.neitui_phone" placeholder="请输入手机号(必填)"
                style="width: 130px" />
            </div>
          </div>
        </div>

        <div class="field_item_box" v-if="add_mianshi_data.belong_type == 'B03'">
          <div class="field_item">
            <div class="field_title">代理名称：</div>
            <Select v-if="agency_user_list" filterable clearable placeholder="请搜索或选择代理用户"
              v-model="add_mianshi_data.belong_id" style="width: 450px">
              <Option v-for="(item, i) in agency_user_list" :value="String(item.value)" :key="item.value">{{ item.label
                }}
              </Option>
            </Select>
          </div>
        </div>

        <div class="yuyue_inner_box" v-if="ext_list.length > 0">
          <div class="yuyue_left_title2">项目附加信息:</div>
          <div class="fujia_div">
            <div class="" v-for="(ext_item, ext_index) in ext_list" :key="ext_index">
              <div class="field_item">
                <div class="field_title">{{ ext_item.title }}：</div>
                <div v-if="ext_item.data_type == 'select'">
                  <Cascader size="small" filterable :data="ext_source_data[ext_item.ext_id]" placeholder="请选择所属地区"
                    v-model="ext_item.value" v-width="200" />
                </div>
                <div v-else>
                  <Input size="small" v-model="ext_item.value" placeholder="请输入" style="width: 200px" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="add_resume_button_opertion">
          <Button type="" @click="add_template_new_mianshi" style="margin-right: 10px; font-size: 12px">
            内推、代理、甲方关系转移数据导入
          </Button>
          <Button type="primary" @click="add_new_mianshi">
            <Icon type="md-add" /> 确认添加
          </Button>
        </div>
      </div>
    </Modal>

    <!-- 更新归属人 -->
    <Modal v-model="update_affiliation_show" title="更新归属人" :footer-hide="true" width="600">
      <div class="field_item_box">
        <div class="field_item">
          <div class="field_title">归属人类型：</div>
          <div>
            <Select v-model="update_affiliation_data.belong_type" style="width: 200px" size="small">
              <Option v-for="(item, i) in belong_type_list" :value="item.value" :key="item.value">{{ item.label }}
              </Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="field_item_box" v-if="update_affiliation_data.belong_type == 'B01'">
        <div class="field_item">
          <div class="field_title">归属人姓名：</div>
          <Select size="small" filterable clearable placeholder="请搜索或选择用户" v-model="update_affiliation_data.belong_id"
            style="width: 450px">
            <Option v-for="(item, i) in sys_user_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
      </div>
      <div v-if="update_affiliation_data.belong_type == 'B02'">
        <div class="field_item_box">
          <div class="field_item">
            <div class="field_title">姓名：</div>
            <Input maxlength="11" v-model="update_affiliation_data.belong_name" placeholder="请输入(必填)"
              style="width: 130px" />
          </div>
          <div class="field_item">
            <div class="field_title">身份证号：</div>
            <Input maxlength="18" v-model="update_affiliation_data.belong_id" placeholder="请输入身份证号(选填)"
              style="width: 200px" />
          </div>
        </div>
        <div class="field_item_box">
          <div class="field_item">
            <div class="field_title">手机号：</div>
            <Input maxlength="11" v-model="update_affiliation_data.neitui_phone" placeholder="请输入手机号(必填)"
              style="width: 130px" />

          </div>
        </div>
      </div>

      <div class="field_item_box" v-if="update_affiliation_data.belong_type == 'B03'">
        <div class="field_item">
          <div class="field_title">代理名称：</div>
          <Select size="small" filterable clearable placeholder="请搜索或选择代理用户" v-model="update_affiliation_data.belong_id"
            style="width: 450px">
            <Option v-for="(item, i) in agency_user_list" :value="item.value" :key="i">{{
              item.label
            }}</Option>
          </Select>
        </div>
      </div>

      <div class="add_resume_button_opertion">
        <Button type="primary" @click="update_guishu_affirm">
          <Icon type="md-add" /> 确认
        </Button>
      </div>
    </Modal>

    <batch_mianshi ref="batch_mianshi"></batch_mianshi>

    <update_idcard2 @change="update_idcard_change" ref="update_idcard2"></update_idcard2>

    <update_job_name @change="update_job_name_change" ref="update_job_name"></update_job_name>

    <resume_detail ref="resume_detail"></resume_detail>

    <update_remarks @change="update_remarks_change" ref="update_remarks"></update_remarks>
    <interview_update_phone ref="interview_update_phone" @change="interview_update_phone_change">
    </interview_update_phone>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import merge from "webpack-merge";
import watermark from "@/utils/shuiyin.js";
import update_idcard2 from "@/views/roster_manage/component/update_idcard2.vue";
import update_job_name from "../roster/update_job_name.vue";
import update_remarks from "../roster/update_remarks.vue";

import batch_mianshi from "../component/batch_mianshi.vue";
import interview_update_phone from '@/views/roster_manage/component/update_phone.vue'
import resume_detail from "@/views/roster_manage/component/resume_detail.vue";
import check_phone_empty from '@/component/interview/check_phone_empty.vue'
export default {
  props: ["project_id"],
  components: {
    update_idcard2,
    batch_mianshi,
    update_job_name,
    update_remarks,
    resume_detail,
    check_phone_empty,
    interview_update_phone
  },
  name: "daimianshi",

  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      project_id: "",
      project_name: "",
      tabs_append: "",

      table_loading: false,
      columns: [],
      table_data: [],
      add_resume_show: false,
      add_mianshi_data: {
        name: "",
        idcard: "",
        phone: "",
        belong_type: "",
        belong_id: "",
        neitui_phone: "",
        beforehand_time: new Date(),
        job: "",
        remarks: "",
      },
      page: 1,
      limit: 20,

      total_count: 0,
      tabs_index: "",
      tabs_show: true,
      flow_class_list: [],

      //选项
      action_list: [],
      is_action: false,
      //归属人
      belong_type_list: [],
      //系统用户列表
      sys_user_list: [],
      // 表格选择数据
      table_selection: [],
      //代理用户列表
      agency_user_list: [],
      search_type: "name",
      search_value: "",

      update_affiliation_show: false,
      update_affiliation_data: {
        interview_id: "",
        belong_type: "B01",
        belong_id: "",
        belong_name: "",
        neitui_phone: "",
      },

      // 更新手机号
      // update_phone_show: false,
      // update_phone_value: "",
      // update_phone_item: {},

      //附加字段
      ext_list: [],
      ext_source_data: {},

      // 按钮loading
      button_loading: false,
      // 需求列表
      need_job_list: [],
      need_job_id: '',
    };
  },

  mounted() {
    var that = this;

    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
  },

  methods: {
    phone_blur() {
      if (this.add_mianshi_data.phone.length == 11) {
        this.$refs.check_phone_empty.open(this.add_mianshi_data.phone)
      }

    },
    page_size_change(e) {
      this.limit = e;
      this.page = 1;

      this.get_daimianshi_list();
    },

    get_project_ext_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/project_ext_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            // that.$Message.success({
            //     content: res.msg,
            //     duration: 3,
            // });
            that.ext_list = res.data.ext_list;
            that.ext_source_data = res.data.ext_source_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    job_refresh(){
      this.get_need_list()
    },
    get_need_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/project_need_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            // that.$Message.success({
            //     content: res.msg,
            //     duration: 3,
            // });

            that.need_job_list = res.data.need_list

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_remarks_change() {
      this.get_daimianshi_list();
    },

    click_update_remarks(row) {
      this.$refs.update_remarks.open(this.project_id, row);
    },

    // 更新岗位
    click_job_name(row) {
      this.$refs.update_job_name.open(this.project_id, row);
    },

    update_job_name_change() {
      this.get_daimianshi_list();
    },

    click_update_phone(row) {
      this.$refs.interview_update_phone.open(row)

    },
    interview_update_phone_change() {
      this.get_daimianshi_list()
    },


    //批量面试
    batch_mianshi() {
      this.$refs.batch_mianshi.open(this.project_id);
    },

    click_get_back() {
      var that = this;

      this.$Modal.confirm({
        title: "提示",
        content:
          "<p>返回上一步后当前状态会删除，员工会恢复到上一步【待操作】状态，操作后无法恢复，真的要继续吗？</p>",
        onOk: () => {
          that.get_back_affirm();
        },
        onCancel: () => { },
      });
    },

    //返回上一步
    get_back_affirm() {
      var interview_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var ivid = this.table_selection[i]["interview_id"];
        interview_id_list.push(ivid);
      }

      if (interview_id_list.length == 0) {
        this.$Message.error("请至少选择一位");
        return;
      }

      var that = this;
      var obj = {
        project_id: this.project_id,
        interview_id_list: interview_id_list,
        flow_id: this.tabs_index,
      };
      that.button_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/get_back", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_daimianshi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.button_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.button_loading = false;
        });
    },

    open() {
      console.log("待面试中打开");
      var that = this;
      var query = this.$route.query;
      if (query.flow_id) {
        this.tabs_index = query.flow_id;
      }
      if (query.project_id) {
        this.project_id = query.project_id;
      }
      if (query.project_name) {
        this.project_name = query.project_name;
      }
      if (query.tabs_append) {
        this.tabs_append = query.tabs_append;
      }

      // project_id:'',
      // project_name:"",
      // tabs_append:'',
      this.get_flow_class_list();
      this.create_shuiyin();
      this.get_project_ext_data();
    },

    click_del_interview() {
      var that = this;
      this.$Modal.confirm({
        title: "危险操作",
        content: "<p>正在删除，是否继续？</p>",
        onOk: () => {
          that.del_interview();
        },
        onCancel: () => { },
      });
    },
    del_interview() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请选择一位");
        return;
      }
      if (this.table_selection.length != 1) {
        this.$Message.error("只可以选择一位");
        return;
      }
      var interview_id = this.table_selection[0]["interview_id"];

      var that = this;
      var obj = {
        interview_id: interview_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/del_daimianshi",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_daimianshi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //确认更新
    update_guishu_affirm() {
      var that = this;
      var obj = {
        interview_id: this.update_affiliation_data.interview_id,
        belong_type: this.update_affiliation_data.belong_type,
        belong_id: this.update_affiliation_data.belong_id,
        belong_name: this.update_affiliation_data.belong_name,
        neitui_phone: this.update_affiliation_data.neitui_phone,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/update_affiliation",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_affiliation_show = false;
            that.get_daimianshi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_update_guishu(row) {
      console.log(row);
      this.get_belong_type();
      this.get_dx_sys_user();
      this.get_dx_agency_user();
      this.update_affiliation_data.interview_id = row.interview_id;
      this.update_affiliation_show = true;
      this.update_affiliation_data.belong_type = row.belong_type_status;
      if (row.belong_type_status == "B01") {
        this.update_affiliation_data.belong_id = row.belong_id;
      }
      if (row.belong_type_status == "B02") {
        console.log("归属人-------");
        this.update_affiliation_data.belong_name = row.belong_name;
        this.update_affiliation_data.belong_id = row.belong_phone;
        this.update_affiliation_data.neitui_phone = row.neitui_phone;
      }
      if (row.belong_type_status == "B03") {
        this.update_affiliation_data.belong_id = row.belong_id;
      }
    },

    //点击更新实名
    click_update_certification(item) {
      var resume_id = item.resume_id;
      var that = this;
      this.$Modal.confirm({
        title: "实名检测",
        content: "<p>确认要对姓名跟身份证进行实名校验吗?" + "</p>",
        onOk: () => {
          that.update_certification_request(resume_id);
        },
        onCancel: () => { },
      });
    },

    update_certification_request(resume_id) {
      var that = this;
      var obj = {
        resume_id: resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/certification",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_daimianshi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击身份证号
    click_idcard_num(item) {
      this.$refs.update_idcard2.open(item);
    },

    update_idcard_change() {
      this.get_daimianshi_list();
    },

    //点击搜索
    search_click() {
      this.page = 1;
      this.get_daimianshi_list();
    },

    create_shuiyin() {
      var user_info = window.localStorage.getItem("user_info");
      if (user_info) {
        var user_info_dict = JSON.parse(user_info);
        var name = user_info_dict.name;
        watermark.set("保密信息-" + name, "220px");
      }
    },
    //模板添加
    add_template_new_mianshi() {
      console.log("模板导入");
      open_new_page(
        "/workbench/my_project/import_daimianshi?project_id=" + this.project_id
      );
    },

    //点击小勾
    tabs_selection_change(e) {
      this.table_selection = e;
    },

    click_action(item) {
      var that = this;
      this.$Modal.confirm({
        title: "操作警告",
        content:
          "<p>确认要更新状态为【" +
          item.label +
          "】吗，更新状态将无法修改，强烈建议检查无误后确认！</p>",
        onOk: () => {
          that.click_action_request(item);
        },
        onCancel: () => { },
      });
    },

    //点击操作按钮,下一个流程
    click_action_request(item) {
      var interview_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var interview_id = this.table_selection[i]["interview_id"];
        interview_id_list.push(interview_id);

        // 如果是签到，就判断是否实名
        // if (item.value == "FLOW_BDF19") {
        //     var row_item = this.table_selection[i]
        //     console.log(row_item)
        //     if (row_item.is_certification == 0) {
        //         this.$Message.error(row_item.name + '-身份证未实名,请先点红色图标进行实名')
        //         return
        //     }
        // }
      }
      if (interview_id_list.length == 0) {
        this.$Message.error("请至少选择一行");
        return;
      }
      if (item.value == "") {
        this.$Message.error("flow_id异常");
        return;
      }

      var that = this;
      var obj = {
        flow_id: item.value,
        current_flow_id: this.tabs_index,
        interview_id_list: interview_id_list,
      };
      that.button_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/next_flow",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_flow_class_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.button_loading = false;
        })
        .catch((res) => {
          that.button_loading = false;
          console.log(res, "请求出错");
        });
    },

    click_new_mianshi_button() {
      this.add_resume_show = true;
      this.get_belong_type();
      // this.get_dx_sys_user();
      this.get_xinmianshi_user();
      this.get_dx_agency_user();
      this.get_project_ext_data();
      this.get_need_list()
    },

    //系统用户列表
    get_dx_sys_user() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/dx_sys_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.sys_user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //系统用户列表
    get_xinmianshi_user() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/add_xinmianshi_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.sys_user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //代理系统列表
    get_dx_agency_user() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/dx_agency_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.agency_user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //归属人类型
    get_belong_type() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/belong_type",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.belong_type_list = res.data.type_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_tabs(e) {
      this.tabs_index = e;
      this.get_daimianshi_list();
      this.get_action_list();
    },

    //获取流程类
    get_flow_class_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/flow_class_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.flow_class_list = res.data.flow_class_list;
            that.tabs_index = that.flow_class_list[0]["value"];

            that.get_daimianshi_list();
            that.get_action_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //获取按钮列表
    get_action_list() {
      var that = this;
      var obj = {
        flow_id: this.tabs_index,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/action_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.is_action = res.data.is_action;
            that.action_list = res.data.action_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取待面试列表
    get_daimianshi_list() {
      var that = this;
      var obj = {
        page: this.page,
        project_id: this.project_id,
        flow_id: this.tabs_index,
        search_type: this.search_type,
        search_value: this.search_value,
      };
      that.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.resume_list;
            that.limit = res.data.limit;
            that.total_count = res.data.total_count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    //添加新面试
    add_new_mianshi() {
      if (this.add_mianshi_data.name == "") {
        this.$Message.error("请输入姓名");
        return;
      }
      // if (this.add_mianshi_data.idcard.length != 18) {
      //     this.$Message.error('请输入18位身份证号')
      //     return
      // }
      if (!this.project_id) {
        this.$Message.error("没有项目id");
        return;
      }
      if (this.add_mianshi_data.beforehand_time == "") {
        this.$Message.error("请选择预约面试时间");
        return;
      }
      // if (this.add_mianshi_data.job == "") {
      //   this.$Message.error("请输入岗位");
      //   return;
      // }

      if (!this.add_mianshi_data.belong_type) {
        this.$Message.error("请选择归属人类型");
        return;
      }
      if (this.add_mianshi_data.belong_type == "B01") {
        if (this.add_mianshi_data.belong_id == "") {
          this.$Message.error("请选择归属人");
          return;
        }
      }
      if (this.add_mianshi_data.belong_type == "B02") {
        if (this.add_mianshi_data.neitui_phone == "") {
          this.$Message.error("请输入内推人手机号");
          return;
        }
        if (this.add_mianshi_data.belong_name == "") {
          this.$Message.error("请输入内推人姓名");
          return;
        }
      }

      var that = this;
      var obj = {
        name: this.add_mianshi_data.name,
        idcard: this.add_mianshi_data.idcard,
        phone: this.add_mianshi_data.phone,
        project_id: this.project_id,
        belong_type: this.add_mianshi_data.belong_type,
        belong_id: this.add_mianshi_data.belong_id,
        belong_name: this.add_mianshi_data.belong_name,
        beforehand_time: Number(this.add_mianshi_data.beforehand_time.getTime() / 1000),
        neitui_phone: this.add_mianshi_data.neitui_phone,
        remarks: this.add_mianshi_data.remarks,
        job: this.add_mianshi_data.job,
        need_job_id:this.need_job_id,
        // 项目附加信息
        project_extras_data: this.ext_list,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/add", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_daimianshi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    page_change(e) {
      this.page = e;
      this.get_daimianshi_list();
    },

    click_name(row) {
      this.$refs.resume_detail.open(row, this.project_id);
    },
  },
};
</script>

<style scoped>
.zyts {
  font-size: 13px;
  background-color: #ff5858;
  color: #fff;
  padding: 10px;
  margin: 10px 5px;
  border-radius: 5px;
}

.idcard2 {
  color: #0466dd;
  cursor: pointer;
}

.button_1 {
  display: flex;
  align-items: center;
}

.phone_span {
  color: #0466dd;
  cursor: pointer;
}

.name {
  color: #0466dd;
  cursor: pointer;
}

.tabs_div {
  padding-right: 100px;
}

.yuyue_left_title2 {
  margin-bottom: 10px;
}

.yuyue_inner_box {
  padding: 10px;
  border-top: 1px dashed #ccc;
}

.update_phone_button {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.phone_icon {
  font-size: 14px;
  cursor: pointer;
  margin-left: 3px;
}

.phone_icon:hover {
  color: #0073ff;
}

.idcard_num {
  cursor: pointer;
  color: #0066e2;
}

.idcard_num:hover {
  color: #0466dd;
}

.search_div {
  display: flex;
  align-items: center;
}

.add_modal {}

.iconweirenzheng {
  font-size: 12px;
  color: #fb0000;
  margin-left: 3px;
  cursor: pointer;
}

.iconrenzheng {
  font-size: 10px;
  color: #01b729;
  margin-left: 3px;
  cursor: pointer;
}

.belong_name {
  color: #0466dd;
  cursor: pointer;
}

.table_div {
  position: relative;
}

.hengxian {
  border-top: 1px dashed #ececec;
  margin: 10px 0;
}

.field_item_box {
  display: flex;
  width: 800px;
  padding-left: 10px;
  align-items: center;
}



.content_page {
  padding: 8px 0 7px 0;
  text-align: center;
}

.page_tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.page_main {
  padding: 0 10px 0px 10px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
}

.add_resume_button_opertion {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.field_title {
  width: 100px;
  flex-shrink: 0;
}

.field_title2 {
  width: 70px;
  flex-shrink: 0;
}

.field_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
}

.button_operation {
  display: flex;
  justify-content: flex-end;
  width: 100px;
}
</style>
